import { EVENT_TYPE } from '../../../lib/analytics-constants';

import mortgageArticles from './mortgage-articles';

export const MORTGAGE = 'mc';
export const MORTGAGE_PAYMENT = 'mpc';
export const MORTGAGE_STATE = 'msc';

export const MORTGAGE_CALCULATOR = {
  RESULTS_HEADER: {
    ENTITY_NAME: 'mrt_calculator',
    SECTION_NAME: 'mrt_calculator',
    FORM_NAME: 'mrt_calculator',
  },
  RELATED_ARTICLES: {
    entityName: 'mortgages_calculator_related_articles',
    sectionName: 'mortgages_calculator_related_articles',
    sectionPosition: 5,
    articles: mortgageArticles,
  },
  RESULTS_HEADER_FORM: {
    EVENT_TYPE: EVENT_TYPE.FORM_IMPRESSION,
    ENTITY_NAME: 'mrt_calculator',
    SECTION_NAME: 'mrt_calculator',
    FORM_NAME: 'mrt_calculator',
  },
  MONTHLY_PAYMENT: {
    EVENT_TYPE: EVENT_TYPE.FORM_IMPRESSION,
    ENTITY_NAME: 'mrt_calculator_monthly_payment',
    SECTION_NAME: 'mrt_calculator_monthly_payment',
    FORM_NAME: 'mrt_calculator_monthly_payment',
    SECTION_POSITION: 0,
  },
};

export const MORTGAGE_STATE_CALCULATOR = {
  RESULTS_HEADER: {
    ENTITY_NAME: 'mrt_calculator',
    SECTION_NAME: 'mrt_calculator',
    FORM_NAME: 'mrt_calculator',
  },
  RELATED_ARTICLES: {
    entityName: 'mortgages_state_calculator_related_articles',
    sectionName: 'mortgages_state_calculator_related_articles',
    sectionPosition: 7,
    articles: mortgageArticles,
  },
  RESULTS_HEADER_FORM: {
    EVENT_TYPE: EVENT_TYPE.FORM_IMPRESSION,
    ENTITY_NAME: 'mrt_calculator',
    SECTION_NAME: 'mrt_calculator',
    FORM_NAME: 'mrt_calculator',
  },
  MONTHLY_PAYMENT: {
    EVENT_TYPE: EVENT_TYPE.FORM_IMPRESSION,
    ENTITY_NAME: 'mrt_calculator_monthly_payment',
    SECTION_NAME: 'mrt_calculator_monthly_payment',
    FORM_NAME: 'mrt_calculator_monthly_payment',
    SECTION_POSITION: 0,
  },
};

export const MORTGAGE_PAYMENT_CALCULATOR = {
  RESULTS_HEADER: {
    ENTITY_NAME: 'mrt_payment_calculator',
    SECTION_NAME: 'mrt_payment_calculator',
    FORM_NAME: 'mrt_payment_calculator',
  },
  RELATED_ARTICLES: {
    entityName: 'mortgages_payment_calculator_related_articles',
    sectionName: 'mortgages_payment_calculator_related_articles',
    sectionPosition: 5,
    articles: mortgageArticles,
  },
  RESULTS_HEADER_FORM: {
    EVENT_TYPE: EVENT_TYPE.FORM_IMPRESSION,
    ENTITY_NAME: 'mrt_payment_calculator',
    SECTION_NAME: 'mrt_payment_calculator',
    FORM_NAME: 'mrt_payment_calculator',
  },
  MONTHLY_PAYMENT: {
    EVENT_TYPE: EVENT_TYPE.FORM_IMPRESSION,
    ENTITY_NAME: 'mrt_calculator_monthly_payment',
    SECTION_NAME: 'mrt_calculator_monthly_payment',
    FORM_NAME: 'mrt_calculator_monthly_payment',
    SECTION_POSITION: 0,
  },
};

export const MORTGAGE_ANALYTICS_HASH = {
  [MORTGAGE]: MORTGAGE_CALCULATOR,
  [MORTGAGE_PAYMENT]: MORTGAGE_PAYMENT_CALCULATOR,
  [MORTGAGE_STATE]: MORTGAGE_STATE_CALCULATOR,
};
